module.exports = __webpack_public_path__ + "static/img/Tristan-Xerri.7a07beb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tristan-Xerri.jpg
// module id = u9lD
// module chunks = 0